import AccountOverview from './AccountOverview';
import Route from './route';

export default {
  RenderProp: AccountOverview,
  mainRoute: Route,
};
